import { render, staticRenderFns } from "./underline.vue?vue&type=template&id=d84a8796&scoped=true"
import script from "./underline.ts?vue&type=script&lang=ts&external"
export * from "./underline.ts?vue&type=script&lang=ts&external"
import style0 from "./underline.scss?vue&type=style&index=0&id=d84a8796&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84a8796",
  null
  
)

export default component.exports